// extracted by mini-css-extract-plugin
export default {"tooltip":"XU-z","arrow":"YU-z"};